/**
 * Auth Service
 * Pure functions for authentication and token management
 */

const TOKEN_KEY = 'contract_token';

/**
 * Save JWT token to session storage
 * @param {string} token - JWT token
 */
export const setAuthToken = (token) => {
  if (token) {
    sessionStorage.setItem(TOKEN_KEY, token);
  } else {
    sessionStorage.removeItem(TOKEN_KEY);
  }
};

/**
 * Get JWT token from session storage
 * @returns {string|null} JWT token or null
 */
export const getAuthToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

/**
 * Clear JWT token from session storage
 */
export const clearAuthToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
};

/**
 * Check if user has a valid token
 * @returns {boolean} True if token exists
 */
export const hasAuthToken = () => {
  return !!getAuthToken();
};
